import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Card, Table } from '@avila-tek/ui/src';
import { useRouter } from 'next/router';
import { Category } from '../../models';
import { ActiveDotCell } from '../shared';

const columnHelper = createColumnHelper<Category>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Nombre',
  }),

  columnHelper.accessor('active', {
    header: 'Estatus',
    cell: (info) => <ActiveDotCell active={info?.getValue()} />,
  }),
];

interface CategoryTableProps {
  data: Category[];
}

function CategoryTable({ data }: CategoryTableProps) {
  const router = useRouter();

  const onClickRow = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    e.preventDefault();
    const { id } = e.currentTarget.dataset;
    router.push(`/app/maintenance/categories/${id}`);
  };

  const onClickAddButton = () =>
    router.push('/app/maintenance/categories/create');

  return (
    <Card className="overflow-x-auto p-5">
      <Table<Category>
        data={data}
        columns={columns}
        href="/app/maintenance/categories/create"
      >
        <Table.Header className="p-6 w-full flex justify-between">
          <Table.SearchInput />
          <Table.AddButton title="Categoría" action={onClickAddButton} />
        </Table.Header>
        <Table.Content<Category> onClickRow={onClickRow} />
        <Table.Footer>
          <Table.Pagination className="ml-auto" />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default CategoryTable;
